import type {
  GetReportRequest,
  GetExportDetailsRequest,
  SearchExportReportsRequest,
  GetReportsRequest,
} from '@trukt/tms-api';
import { createKey } from './createKey';

const exportHandlerKey = createKey('export-report');
const reportHandlerKey = createKey('report');

const ExportReportServiceKeys = {
  key: exportHandlerKey.key,
  search: exportHandlerKey.createMethod<SearchExportReportsRequest>(),
  getById: exportHandlerKey.createMethod<GetExportDetailsRequest>(),
};

export const ReportServiceKeys = {
  key: reportHandlerKey.key,
  exports: ExportReportServiceKeys,
  search: reportHandlerKey.createMethod<GetReportsRequest>(),
  getById: reportHandlerKey.createMethod<GetReportRequest>(),
};
